export default __webpack_public_path__ + "static/media/640_store03-jp-web.ee812f15.png";